import * as yup from "yup";

export const RequisitionValidationSchema = yup.object().shape({
    requisition_type: yup
        .object()
        .shape({
            id: yup.number().required("Requisition Type is Required"),
            label: yup.string(),
            name: yup.string(),
        })
        .typeError("Please select Requisition Type"),
    requisition_date: yup.date().required("Requisition date is Required").nullable(),
    supplier: yup
        .object()
        .shape({
            id: yup.number().required("Supplier is Required"),
            label: yup.string(),
            name: yup.string(),
        })
        .typeError("Please select Supplier"),
    remark: yup.string().max(100, "Remark not more than 100 characters."),
    requisition_items: yup.array().of(
        yup.object().shape({
            product: yup.object().shape({
                id: yup.number().required("Item is Required"),
                name: yup.string(),
                label: yup.string(),
            })
            .typeError("Please select Item from dropdown"),
            order_quantity: yup.number().required("Order quantity is Required"),
        })
    ),
});
